import { useState, useEffect } from "react";
import Drawer from "../drawer/Drawer.jsx";
import CustomButton from "../kits/custom-button/CustomButton";
import { CustomInput } from "../kits/inputs/Input.tsx";
import colorSchema from "../../assets/kits/colors";
import useAxios from "../../services/useAxios";
import { from } from "jalali-moment";

export default function DiscountCodeDrawer({
  isOpen,
  setIsOpen,
  setDiscount,
  setGiftId,
  total,
  setJustDiscount,
}) {
  const { execute: checkGifCode } = useAxios("api/check_giftcode");

  const [offCode, setOffCode] = useState("");
  const [textType, setTextTyp] = useState("none");
  const [errorText, setErrorText] = useState("کد تخفیف اشتباه وارد شده است.");
  const checkCode = (code) => {
    let form = new FormData();
    form.append("giftCode", code);
    checkGifCode(form).then((data) => {
      if (data.status == -2) {
        setTextTyp("error");
        setErrorText("متعلق به این کاربر نیست یا کد هدیه اشتباه است");
      } else if (data.status == -3) {
        setTextTyp("error");
        setErrorText("تاریخ انقضا کد به اتمام رسیده است");
      } else if (data.status == -4) {
        setTextTyp("error");
        setErrorText("کد قبلا استفاده شده است");
      } else if (data.status == 1) {
        if (data.result.type == 0) {
          setDiscount((+data.result.value * total) / 100);
          setJustDiscount((+data.result.value * total) / 100);
        } else {
          setDiscount(data.result.value);
          setJustDiscount(data.result.value);
        }
        setTextTyp("none");
        setIsOpen(false);
        setGiftId(data.result.id);
      }
    });
  };
  {
    /* checkout drawer */
  }

  return (
    <Drawer isOpen={isOpen} height={237} onClose={() => setIsOpen(false)}>
      <div>
        <h3
          className="title-h3-b mr-r-20 mr-t-16"
          style={{ color: colorSchema.foreground_background_he }}
        >
          اعمال کد تخفیف
        </h3>
        <div className="mr-t-16 mr-x-20" style={{ height: 92 }}>
          <CustomInput
            labelClassName="txt-t3-m"
            textType={textType}
            className="mr-y-4"
            title="کد تخفیف"
            placeholder="کد تخفیف را وارد کنید"
            messageText={errorText}
            value={offCode}
            onChange={(e) => {
              setOffCode(e.target.value);
            }}
          ></CustomInput>
        </div>
        <div className="mr-x-20 mr-t-8">
          <CustomButton
            onClick={() => checkCode(offCode)}
            style={{ width: "100%", height: "48px" }}
            buttonStyle="primary"
          >
            اعمال کد تخفیف
          </CustomButton>
        </div>
      </div>
    </Drawer>
  );
}
